// extracted by mini-css-extract-plugin
module.exports = {"link":"GatsbyLink--link--2AFcz"};